"use client"

import { NftSearchScopeProvider } from "@/app/nft/search/scope-provider"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { useSearchParams } from "next/navigation"
import { useMemo, useState } from "react"

import {
  SERIALIZED_FILTER_VALIDATOR,
  SORT_VALIDATOR,
} from "@/app/collections/items/utils"
import type { ScopeState } from "@/app/nft/search/scope"
import type { UnionAddress } from "@anaconda/core/blockchain/address"
import { DEFAULT_STATUS } from "@anaconda/core/nft/search/constants"

interface Props {
  children: React.ReactNode
  collectionId: CollectionId
  owner?: UnionAddress
}

export function CollectionItemsSearchProvider(props: Props) {
  const params = useSearchParams()
  const [initialParamas] = useState(params)
  const filters = useMemo(() => {
    const initialFilters: ScopeState["filters"] =
      SERIALIZED_FILTER_VALIDATOR.safeParse(initialParamas.get("filters"))
        .data ?? { status: DEFAULT_STATUS }

    if (props.owner) {
      initialFilters.owner = props.owner
    }

    return initialFilters
  }, [initialParamas, props.owner])

  const state = useMemo(
    () => ({
      filters: {
        ...filters,
        collection: props.collectionId,
      },
      sort: SORT_VALIDATOR.safeParse(initialParamas.get("sort")).data,
    }),
    [props.collectionId, filters, initialParamas],
  )

  return (
    <NftSearchScopeProvider state={state}>
      {props.children}
    </NftSearchScopeProvider>
  )
}
